import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { theme } from '../../constants/theme.mjs';
import { Container } from './StaticModal.styles.mjs';
"use strict";
const StaticModal = ({
  show,
  width,
  minHeight,
  clean,
  hasOverlay,
  children
}) => {
  const overlayStyles = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.25)",
    backdropFilter: "blur(4px)",
    zIndex: theme.zIndex.modal,
    pointerEvents: "auto"
  };
  const overlayElement = /* @__PURE__ */jsx("div", {
    style: overlayStyles
  });
  const modalContent = /* @__PURE__ */jsx(Container, {
    show,
    clean,
    width,
    minHeight,
    style: {
      ...(hasOverlay ? {
        zIndex: theme.zIndex.modal,
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
      } : {})
    },
    children
  });
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (show && hasOverlay) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = originalOverflow;
      };
    }
    return void 0;
  }, [show, hasOverlay]);
  if (!show || typeof window === "undefined") return null;
  return /* @__PURE__ */jsx(Fragment, {
    children: hasOverlay ? createPortal(/* @__PURE__ */jsxs(Fragment, {
      children: [overlayElement, modalContent]
    }), document.body) : modalContent
  });
};
export { StaticModal };
//# sourceMappingURL=StaticModal.mjs.map
